//CONSTANTES
const TOGGLE_AUDIT_ADMINISTRATION = "TOGGLE_AUDIT_ADMINISTRATION";

const GET_GROUPSLAYOUT = "GET_GROUPSLAYOUT";
const GET_GROUPSLAYOUT_SUCCESS = "GET_GROUPSLAYOUT_SUCCESS";
const GET_GROUPSLAYOUT_FAIL = "GET_GROUPSLAYOUT_FAIL";

const initialState = {
  isOpen: false,
  data: [],
  isLoading: false,
  hasError: false,
  layoutIsPublic: false,
};

//Reducer se exporta por default;
export default function help(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_AUDIT_ADMINISTRATION: {
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    }

    case GET_GROUPSLAYOUT: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case GET_GROUPSLAYOUT_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        isLoading: false,
        layoutIsPublic: action.payload.status === 204,
      };
    }

    case GET_GROUPSLAYOUT_FAIL: {
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    }

    default:
      return state;
  }
}

export const toggleAdministrationAudit = () => {
  return { type: TOGGLE_AUDIT_ADMINISTRATION };
};

export const getUsersWithAccess = (layoutId) => {
  return {
    type: GET_GROUPSLAYOUT,
    payload: {
      request: {
        url: "auth/GetUsers/" + layoutId,
      },
    },
  };
};

export const getUsersWithAccessCustom = (menuItemId) => {
  return {
    type: GET_GROUPSLAYOUT,
    payload: {
      request: {
        url: "auth/GetUsersMenuItem/" + menuItemId,
      },
    },
  };
};
